import { useAppPathname } from "@/routing/navigation";
import { RouteLink } from "@/components/common/styles";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import type { JSX, ReactNode } from "react";
import type { LinkComponentProps } from "@tanstack/react-router";
import MenuIcon from "../NavMenu/MenuIcon";

export default function NavListItem({
  title,
  to,
  alternativeTo,
  autoCloseDrawer,
  icon,
  badge,
}: {
  title: string;
  to: LinkComponentProps["to"];
  alternativeTo?: LinkComponentProps["to"][];
  autoCloseDrawer: () => void;
  icon: JSX.Element;
  badge?: ReactNode;
}) {
  const pathname = useAppPathname();
  const isSelected =
    to === pathname ||
    (alternativeTo?.some((alt) => alt === pathname) ?? false);
  return (
    <ListItem key={"key-list-item-" + title} disablePadding>
      <RouteLink to={to} style={{ flex: 1 }}>
        <ListItemButton
          onClick={autoCloseDrawer}
          data-testid={`NavLink_${title.replace(/[ \&]+/g, "_")}`}
          sx={{ paddingLeft: "8px", paddingRight: "8px" }}
          selected={isSelected}
        >
          <ListItemIcon sx={{ minWidth: "36px" }}>
            <MenuIcon icon={icon} selected={isSelected} />
          </ListItemIcon>
          <ListItemText primary={title} />
          {badge}
        </ListItemButton>
      </RouteLink>
    </ListItem>
  );
}
